import React, {useState} from 'react';
import Layout from '../Layout/Layout';
import {
    GridItem,
    TextAreaStyled,
    TextFieldStyled,
    TextStyled
} from '@nike/nike-design-system-components';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import LevelSelection from '../LevelSelection/LevelSelection';
import type {BatchReceiverRequest} from '../../api/batchReceiver';
import { useAuthStore, selectUsername } from '@nike/aegis-auth-react';
import UserProfile from '../UserProfile/UserProfile';

const DataEntryPage = () => {
    useDocumentTitle('Consumer Account Remediation');

    const consumerIdLimit: number = 15_000;
    const [issueId, setIssueId] = useState<string>('');
    const [textData, setTextData] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState<string>('');
    const requesterId = useAuthStore(selectUsername); //set the requesterId from OKTA

    const handleError = (message: string) => {
        setErrorMessage(message);
    };

    const handleSuccess = () => {
        setErrorMessage('');
    }

    const handleValidation = (lockoutLevel: string | null): BatchReceiverRequest | null => {
        console.log("handleValidation with accessLevel: " + lockoutLevel);
        //remove superfluous separators at the start of the string
        let textDataTrimmed:string = textData.replace(/^[,\s]+/, "");
        //remove superfluous separators at the end of the string
        textDataTrimmed = textDataTrimmed.replace(/[,\s]+$/, "");
        //split on commas, whitespace (including newlines); any run of commas and whitespace without intervening data should be removed automatically due to the '+' in the regex.
        let consumerIds: string[] = textDataTrimmed.split(/[,\s]+/);
        if (textDataTrimmed.length === 0 || consumerIds.length === 0) {
            handleError("UPMID(s) required");
            return null;
        } else if (consumerIds.length > consumerIdLimit) {
            handleError("Too many UPMIDs: " + consumerIds.length);
            return null;
        }
        if (lockoutLevel && ["SESSION", "PASSWORD", "ACCESS"].indexOf(lockoutLevel) === -1) {
            handleError("Select a valid access level");
            return null;
        }
        return {
            requesterId,
            issueId,
            lockoutLevel,
            consumerIds
        } as BatchReceiverRequest;
    }

    return (
        <Layout
            justifyItems="start"
            justifyContent="start"
            alignContent="start"
            alignItems="start"
        >
            <GridItem
                style={{
                  padding: "24px 0px",
                  width: "100%"
                }}
            >
                <TextStyled
                    appearance="title3"
                    Component="h1"
                    style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                >
                  Consumer Account Remediation
                  <UserProfile />
                </TextStyled>
            </GridItem>
            <GridItem>
                <TextStyled
                    appearance="body2"
                    
                >
                    If applicable, enter the incident or Jira ticket number for the UPMID(s) and/or Email(s) to be managed:
                </TextStyled>
            </GridItem>
            <GridItem>
                <TextFieldStyled
                    ariaLive="polite"
                    autoComplete="off"
                    id="ticketNumberArea"
                    label="Incident or Jira Ticket Number"
                    maxLength={15}
                    name="ticket"
                    style={{width: '25em'}}
                    value={issueId}
                    onChange={it => setIssueId(it.target.value)}
                />
            </GridItem>
            <GridItem>
                <TextStyled
                    appearance="body2"
                    
                >
                    Please enter a list of UPMID(s) and/or Email(s) to manage:
                </TextStyled>
            </GridItem>
            <GridItem>
                <TextAreaStyled
                    ariaLive="polite"
                    autoComplete="off"
                    cols={100}
                    errorMessage={errorMessage}
                    id="dataTextArea"
                    label="Paste UPMID(s) and/or Email(s)(separated by commas, spaces, or newlines)"
                    name="data"
                    value={textData}
                    onChange={it => setTextData(it.target.value)}
                    rows={10}
                    spellCheck={false}
                    requiredIndicator={'*'}
                    /* @ts-ignore */
                    supportText={
                        <span>
              <span
                  style={{
                      color: "#D30005",
                      float: 'left',
                  }}
              >
                {errorMessage}
              </span>
              <span>Maximum of 15,000 UPMID(s) and/or Email(s) per batch</span>
            </span>
                    }
                    supportTextProps={{style: {textAlign: 'right'}}}
                    showCharacterCount={false}
                    wrap="soft"
                />
            </GridItem>
            <LevelSelection handleValidation={handleValidation} onError={handleError} onSuccess={handleSuccess} textData={textData}/>
        </Layout>
    );
};

export default DataEntryPage;
